import React from 'react';
import { connect } from 'react-redux';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';
import Idle from 'react-idle'

import Nav from './shared/components/nav';
import SiteHead from './shared/components/header';
import Notificaciones from './components/notificaciones/notificaciones'

import Dashboard from './views/dashboard';
import OldTickets from './views/oldtickets';
import Tickets from './views/ticket';
import Page404 from './views/errors/404';
import Reportes from './views/reportes';
import Departamentos from './views/departamentos';
import Clientes from './views/clientes';
import User from './views/user';
import Inventario from './views/inventario';
import Categorias from './views/categorias';
import Descuentos from './views/descuentoscontpaq';
import PassModal from './components/changePassword/modalPass';
import Logout from './views/signin/logout';
import Facturacion from './views/facturacion';
import Insidencias from './views/insidencias';
import InvoiceModule from './views/facturacion/invoiceModule'
import Menuf from './views/facturacion/menu';
import Eventos from './views/eventos';


import * as actions from './actions/auth';

import './app.css';

class App extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            navMini : true,
            passModal   : false,
        }

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        let { authenticated } = this.props.auth;

        if(authenticated) {
            this.props.whoiam();
        }
    }

    toggleNav = (e) => {
        e.preventDefault();
        this.setState({navMini: !this.state.navMini});
    }

    hideNav = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.setState({navMini: false})
    }

    handleClick() {
        this.props.signout();
    }

    toggleChangePass = (e) =>{
        this.setState({
            passModal: !this.state.passModal,
        });
    }


    render() {

        let navMini = this.state.navMini;

        let {authenticated, user,permisos} = this.props.auth;
       console.log('tamaño',window.screen.height)
        if(!authenticated)
            return (<Redirect to={{pathname: '/'}} />);

        return (


               <Idle
                  //30 min
                  timeout={1800000}
                  //5 min
                 //timeout={300000}
                render={({ idle }) =>
                  <HashRouter basename='app'>
                    {(idle)
                      ? <Logout inactivo={idle} onClick={this.handleClick}/>
                      : 
                <div className="app-wrapper">
               


                    <Notificaciones/>
                    <Nav mini={navMini} toggleNav={this.toggleNav} ocultar={this.hideNav} user={user} permisos={permisos} />

                    <div className={`content-container ${navMini ? 'full' : ''}`}>
                       
                        <div 
                         className="menu-dropshadow" 
                         style={{display: (navMini ? 'block': 'none')}} 
                         onClick={this.hideNav}></div>
                        
                        <SiteHead toggleNav={this.toggleNav} onClick={this.handleClick} inactivo={idle} user={user} permisos={permisos} ChangePass={this.toggleChangePass} />
                         
                        <Switch>
                            <Route exact path="/" component={Dashboard} />
                            <Route path="/old_tickets" component={OldTickets} />
                            <Route path="/tickets" component={Tickets} />
                            <Route path="/insidencias" component={Insidencias} />
                            <Route path="/reportes" component={Reportes} />
                            <Route path="/departamentos" component={Departamentos} />
                            <Route path="/clientes" component={Clientes} />
                            <Route path="/usuarios" component={User} />
                            <Route path="/inventario" component={Inventario} />
                            <Route path="/categorias" component={Categorias} />
                            <Route path="/descuentos" component={Descuentos} />
                            <Route path="/facturacion" component={Facturacion} />
                            <Route path="/invoiceModule" component={InvoiceModule}/>
                            <Route path="/eventos" component={Eventos}/>
                           
                            <Route component={Page404} />
                            
                        </Switch>

                    </div>
                    <PassModal
                        open2={this.state.passModal}
                        toggleE={this.toggleChangePass}
                    />
                </div>
           
                    }
                   </HashRouter>
                }
              />

            
        );

    }
};

function mapStateToProps(state, ownProps) {
    return {
        auth : state.auth
    }
}

export default connect(mapStateToProps, actions)(App);





// WEBPACK FOOTER //
// ./src/App.js